export default "__VITE_ASSET__DCk4ZuqM__"